import { ReactNode } from 'react';

import Paragraph from '@/design_system/Typography/Paragraph';
import { useRequestContext } from '@/routes/Requests/contexts/RequestContext';

export const PricesLine = ({
  label,
  fontWeight,
  workshopPrice,
  type,
  organizationPrice,
  disabled = false,
}: {
  label: ReactNode;
  fontWeight: 'regular' | 'medium';
  workshopPrice?: ReactNode;
  organizationPrice?: ReactNode;
  type?: 'organization' | 'workshop' | undefined;
  disabled?: boolean;
}) => {
  const { view: requestView } = useRequestContext();

  return (
    <>
      <Paragraph weight={fontWeight} color={disabled ? 'disabled' : undefined}>
        {label}
      </Paragraph>
      {(!type || type === 'workshop') && requestView.workshopPrice.shown && workshopPrice}
      {(!type || type === 'organization') &&
        requestView.organizationPrice.shown &&
        organizationPrice}
    </>
  );
};
